import RestApiModel from "@/api/Model/RestApiModel";
import api from '@/api';

class ReportOptions extends RestApiModel {
  static getResourceEndpoint() {
    return '/ReportOptions';
  }
  static getReportOptions(language) {
    return api.get(this.getResourceEndpoint(), {
      params: {
        language
      }
    });
  }
}

export default ReportOptions;
